import { Alert, Button, ButtonGroup, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/system";

interface FMEChipProps {
  fmeId: number;
  debit: number;
  covered: number;
  currencySymbol: string;
  onDelete?: () => void;
}

const FMEChip = ({
  fmeId,
  debit,
  covered,
  currencySymbol,
  onDelete,
}: FMEChipProps) => {
  return (
    <ButtonGroup
      variant="outlined"
      sx={{
        height: "28px",
        borderRadius: "6px",
        overflow: "hidden",
        backgroundColor: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        "& .MuiButton-root": {
          minWidth: "unset",
          px: 1,
          fontSize: "13px",
          fontWeight: 500,
          textTransform: "none",
          borderColor: "#e0e0e0",
        },
      }}
    >
      {/* FME ID */}
      <Button disableRipple sx={{ color: "#212121" }}>
        {fmeId}
      </Button>

      {/* Amount */}
      <Button disableRipple sx={{ color: "#212121" }}>
        <Stack direction={"row"} gap={1}>
          {debit.toFixed(2)}
          {currencySymbol}
          {/* Coverage (Alert as badge) */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {covered > 100 ? (
              <Alert
                severity="success"
                variant="outlined"
                icon={false}
                sx={{
                  height: "22px",
                  px: "6px",
                  py: 0,
                  mx: 0.5,
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "4px",
                  backgroundColor: "#f5e8e8",
                  color: "#b02727",
                  borderColor: "#e6c8c8",
                  pointerEvents: "none",
                  "& .MuiAlert-message": {
                    padding: 0,
                  },
                }}
              >
                {covered}%
              </Alert>
            ) : (
              <Alert
                severity="success"
                variant="outlined"
                icon={false}
                sx={{
                  height: "22px",
                  px: "6px",
                  py: 0,
                  mx: 0.5,
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "4px",
                  backgroundColor: "#e8f5e9",
                  color: "#1e4620",
                  borderColor: "#c8e6c9",
                  pointerEvents: "none",
                  "& .MuiAlert-message": {
                    padding: 0,
                  },
                }}
              >
                {covered}%
              </Alert>
            )}
          </Box>
        </Stack>
      </Button>

      {/* Delete */}
      <Button
        sx={{
          px: 0.5,
          color: "#707070",
          "&:hover": {
            backgroundColor: "rgba(156,39,176,0.08)",
          },
        }}
        onClick={onDelete}
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </Button>
    </ButtonGroup>
  );
};

export default FMEChip;
